import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/** Service Injectable */
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  /** boolean value whether a service call is in progress */
  isServiceHit: boolean;
    /** To store comments */
    public otpVerified = new Subject<any>();
    /** to share otpVerified which can be subscribed, */
    public otpVerified$ = this.otpVerified.asObservable();
        /** To store comments */
        public sharedScreen = new Subject<any>();
        /** to share sharedScreen which can be subscribed, */
        public sharedScreen$ = this.sharedScreen.asObservable();
    /**isSkippedBoolean value */
    public isSkippedIncome:boolean;
    /** loading Message value */
    public loadingMessage:string;
    /** token succes */
    tokenSuccess = new Subject<any>();
    /** token Failure */
    tokenFailure = new Subject<any>(); 
  /**
   * Method to initialize Service
   */
  constructor() { 
    this.loadingMessage="";
  }
/**
 * paasing otp status
 * @param status passing  otp status
 */
setOtpStatus(status): void {
  this.otpVerified.next(status);
}
/**
 * fetching step data
 * @param status passing status
 */
setStepData(status): void {
  this.sharedScreen.next(status);
}
/**
 * getting value if type income
 * @param type passing type value
 * @param value passing skipincome value
 */
setIsSkipped(type,value){
if(type=='income'){
  this.isSkippedIncome=value;
}
}
/**
 * fetching boolean value 
 * @param type passing type value
 * @returns boolean value of skip .
 */
getIsSkipped(type){
  if(type=='income'){
   return this.isSkippedIncome;
  }
  return false;
}
/**
 * This method provides an observable which can be subscribed to in order to listen for token success events.
 * @returns {Observable<any>} An observable that emits token success events.
 */
getTokenSuccess(): Observable<any>{
  return this.tokenSuccess.asObservable();
}
/**
 * Returns an observable that emits token failure events.
 * This method provides an observable which can be subscribed to in order to listen for token failure events.
 * @returns {Observable<any>} An observable that emits token failure events.
 */
 getTokenFailure(): Observable<any> {
  return this.tokenFailure.asObservable();
}

}
